module.exports = __webpack_public_path__ + "static/img/logo-light.7026fbf8.svg";